import { Typography } from 'antd';
import React, { memo } from 'react';

import IconLabel from 'components/atoms/IconLabel';

type StackedIconTitleIconComponent = React.ComponentType<{ size: number }>;

type StackedIconTitleProps = {
  /** Rendered as `<Icon size={130} />`. */
  Icon: StackedIconTitleIconComponent;
  title: string;
  /** Rendered as secondary text. */
  subTitle?: string | JSX.Element;
};

function StackedIconTitle({ Icon, title, subTitle }: StackedIconTitleProps): JSX.Element {
  const label = subTitle
    ? (
      <div>
        <Typography.Title level={3}>{title}</Typography.Title>
        <Typography.Text type="secondary">{subTitle}</Typography.Text>
      </div>
    )
    : <Typography.Title level={3}>{title}</Typography.Title>;
  return (
    <IconLabel
      direction="vertical"
      gap={24}
      icon={<Icon size={130} />}
      label={label}
    />
  );
}

export default memo(StackedIconTitle);
export type { StackedIconTitleProps, StackedIconTitleIconComponent };
